import {addDoc, collection, doc, getDoc, setDoc,} from "firebase/firestore";
import {getDb} from "util/Constants";

export const createLevels = async (
    mini,
    eventId,
    meta,
    easyLevelScore,
    projectType
) => {
    let numLevels;
    if (projectType === "progress") {
        numLevels = 6;
        await createProgressLevels(numLevels, mini, eventId, easyLevelScore, meta);
        // numLevels = 6;
        // await createAceLevels(
        //   numLevels,
        //   mini,
        //   eventId,
        //   easyLevelScore,
        //   meta,
        //   projectType
        // );
    } else {
        numLevels = 6;
        await createAceLevels(
            numLevels,
            mini,
            eventId,
            easyLevelScore,
            meta,
            projectType
        );
    }

    const docRef = doc(getDb(), "miscellaneous", eventId);
    setDoc(docRef, {
        data: meta.miscellaneous,
    });
};

const createProgressLevels = async (
    numLevels,
    mini,
    eventId,
    easyLevelScore,
    meta,
    projectType
) => {
    const levelsData = meta.progressLevels;
    let levelsArray = [];
    // inprogress doing this part outside of the loop as all the levels have same miniAttempts and totalQuestions

    for (let i = 0; i < numLevels; i++) {
        let value = i + 1;
        let totalGenerated = levelsData[value].split("|");
        let question = parseInt(totalGenerated[0]);
        let email = parseInt(totalGenerated[1]);
        let sms = parseInt(totalGenerated[2]);

        let sum = levelsData[value]
            .split("|")
            .map(Number)
            .reduce(function (a, b) {
                return a + b;
            }, 0);

        let totalQuestion = levelsData[value]
            .split("|")
            .map(function (num) {
                return Math.floor(parseFloat(num) + 2);
            })
            .join("|");

        let passingScoreLvl = sum * easyLevelScore;
        let goalTextLevel = `Your mission is to achieve minimum of:\n- ${passingScoreLvl} points \n- Answering ${question} colleagues \n- Checking ${email} Email \n- Responding to ${sms} message`;

        levelsArray.push({
            tabName: value.toString(),
            minAttempt: levelsData[value],
            totalQuestion: totalQuestion,
            passingScore: passingScoreLvl,
            goalText: goalTextLevel,
            time: sum * 15,
        });
        // handle mini games:
        // - if exactly 2 mini games: push two levels, then push first mini, then two levels, then second mini
        // - if more than 2: alternate one level then the corresponding mini when available
        if (Array.isArray(mini) && mini.length > 0) {
            if (mini.length === 2) {
                // push first mini after level 2 (i === 1) and second mini after level 4 (i === 3)
                if (i === 1 && mini[0]) {
                    levelsArray.push(mini[0]);
                }
                if (i === 3 && mini[1]) {
                    levelsArray.push(mini[1]);
                }
            } else {
                if (mini.length > i) {
                    levelsArray.push(mini[i]);
                }
            }
        }
    }
    console.log(levelsArray);
    await pushDbLevels(levelsArray, eventId);
};

const createAceLevels = async (
    numLevels,
    mini,
    eventId,
    easyLevelScore,
    meta,
    projectType
) => {
    const levelsData = meta.levelsConfig;
    let levelsArray = [];
    for (let i = 0; i < numLevels; i++) {
        let value = i + 1;

        let totalGenerated = levelsData[value].split("|");
        let question = parseInt(totalGenerated[0]);
        let email = parseInt(totalGenerated[1]);
        let sms = parseInt(totalGenerated[2]);

        let sum = levelsData[value]
            .split("|")
            .map(Number)
            .reduce(function (a, b) {
                return a + b;
            }, 0);

        let totalQuestion = levelsData[value]
            .split("|")
            .map(function (num) {
                return Math.floor(parseFloat(num) * 1.5);
            })
            .join("|");

        let passingScoreLvl = sum * easyLevelScore;

        let goalTextLevel = `Your mission is to achieve minimum of:\n- ${passingScoreLvl} points \n- Answering ${question} colleagues \n- Checking ${email} Email \n- Responding to ${sms} message`;

        levelsArray.push({
            tabName: value.toString(),
            minAttempt: levelsData[value],
            totalQuestion: totalQuestion,
            passingScore: passingScoreLvl,
            goalText: goalTextLevel,
            time: sum * 15,
        });
        if (mini.length > i) {
            levelsArray.push(mini[i]);
        }
    }
    await pushDbLevels(levelsArray, eventId);
};

const pushDbLevels = async (levelsArray, eventId) => {
    for (let i = 0; i < levelsArray.length; i++) {
        const docRef = await addDoc(collection(getDb(), "Levels"), {
            totalQuestion: levelsArray[i].tabName.startsWith("Mini")
                ? "L=1"
                : levelsArray[i].totalQuestion,
            minAttempt: levelsArray[i].tabName.startsWith("Mini")
                ? "5"
                : levelsArray[i].minAttempt,
            type: levelsArray[i].tabName.startsWith("Mini")
                ? levelsArray[i].type
                : "Behavorial",
            tabName: levelsArray[i].tabName,
            evaluation: levelsArray[i].evaluation ?? "",
            nbrOfQues: levelsArray[i].nbrOfQues ?? 0,
            name: levelsArray[i].name ?? "",
            sortingOrder: (i + 1).toString(),
            goalText: levelsArray[i].goalText,
            difficulty: "Easy",
            passingScore: levelsArray[i].passingScore,
            time: levelsArray[i].time,
            final:
                i === levelsArray.length - 2
                    ? "y"
                    : i === levelsArray.length - 1
                        ? "d"
                        : "n",
            eventId: eventId,
        });
    }
};

export const createEvent = async (
    eventData,
    db,
    signedInUser,
    departments_Regions
) => {
    await setDoc(doc(db, "Events", eventData.eventId), {
        ...eventData,
        userId: signedInUser.uid,
        projectType: signedInUser.projectType || "",
        departments: departments_Regions.departments,
        region: departments_Regions.regions,
    });
};

export const creatingEventQuestions = (
    selected,
    levels,
    questionsCount,
    eventId,
    diff,
    pushFunction
) => {
    let difficulty = diff;
    const generatedData = [];
    const selectedCheckboxes = [];
    selected.map((e) => selectedCheckboxes.push(e.name));

    for (let i = 0; i < levels.length; i++) {
        const levelData = {levels: []};

        let totalGenerated = levels[i].minAttempt.split("|");

        let question = parseInt(totalGenerated[0]);
        let email = parseInt(totalGenerated[1]);
        let sms = parseInt(totalGenerated[2]);

        if (selectedCheckboxes?.length > 0) {
            let questionsPerCheckbox = Math.ceil(
                question / selectedCheckboxes.length
            );
            let questionMultiple = questionsPerCheckbox * 2;

            for (let j = 0; j < selectedCheckboxes.length; j++) {
                let checkboxName = selectedCheckboxes[j];
                let questionsToAdd = questionMultiple;

                for (let k = 0; k < questionsToAdd; k++) {
                    if (difficulty === "Easy") {
                        let difficult =
                            k < Math.floor(questionsToAdd * 0.75) ? "Easy" : "Hard";
                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-Question`
                        );
                    } else if (difficulty === "Hard") {
                        let difficult =
                            k < Math.floor(questionsToAdd * 0.5) ? "Easy" : "Hard";
                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-Question`
                        );
                    }
                }
            }
        }

        if (selectedCheckboxes?.length > 0) {
            let emailsPerCheckbox = Math.ceil(email / selectedCheckboxes.length);
            let emailsMultiple = emailsPerCheckbox * 2;

            for (let j = 0; j < selectedCheckboxes.length; j++) {
                let checkboxName = selectedCheckboxes[j];
                let emailsToAdd = emailsMultiple;

                for (let k = 0; k < emailsToAdd; k++) {
                    if (difficulty === "Easy") {
                        let difficult =
                            k < Math.floor(emailsToAdd * 0.75) ? "Easy" : "Hard";

                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-Email`
                        );
                    } else if (difficulty === "Hard") {
                        let difficult = k < Math.floor(emailsToAdd * 0.5) ? "Easy" : "Hard";
                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-Email`
                        );
                    }
                }
            }
        }

        if (selectedCheckboxes?.length > 0) {
            let smsPerCheckbox = Math.ceil(sms / selectedCheckboxes.length);
            let smsMultiple = smsPerCheckbox * 2;

            for (let j = 0; j < selectedCheckboxes.length; j++) {
                let checkboxName = selectedCheckboxes[j];
                let smsToAdd = smsMultiple;

                for (let k = 0; k < smsToAdd; k++) {
                    if (difficulty === "Easy") {
                        let difficult = k < Math.floor(smsToAdd * 0.75) ? "Easy" : "Hard";

                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-SMS`
                        );
                    } else if (difficulty === "Hard") {
                        let difficult = k < Math.floor(smsToAdd * 0.5) ? "Easy" : "Hard";
                        levelData.levels.push(
                            `${checkboxName}-${levels[i].tabName}-${difficult}-SMS`
                        );
                    }
                }
            }
        }
        generatedData.push(levelData);
        console.log(levelData);
    }

    const lastArray = getQuestionsfromBank(
        generatedData,
        questionsCount,
        eventId,
        pushFunction
    );
    return lastArray;
};

const getQuestionsfromBank = async (
    generatedIds,
    questionsCount,
    eventId,
    pushFunction
) => {
    const uniqueNumbers = {};
    const levelsArray = [];

    await Promise.all(
        generatedIds.map(async (e) => {
            await Promise.all(
                e.levels.map(async (level) => {
                    if (questionsCount[level]) {
                        if (!uniqueNumbers[level]) {
                            uniqueNumbers[level] = [];
                        }
                        const maxNumber = questionsCount[level];
                        const usedNumbers = uniqueNumbers[level].length;
                        if (usedNumbers >= maxNumber) {
                            return;
                        }
                        let num;
                        do {
                            num = generateRandomNumber(maxNumber);
                        } while (uniqueNumbers[level].includes(num));
                        uniqueNumbers[level].push(num);
                        const docRef = doc(
                            getDb(),
                            "Metadata_QuestionBank",
                            level + "-" + num
                        );
                        const docSnap = await getDoc(docRef);

                        if (docSnap.exists()) {
                            levelsArray.push(docSnap.data());
                        } else {
                        }
                    }
                })
            );
        })
    );
    const lastArray = await pushQuestions(levelsArray, eventId, pushFunction);
    return lastArray;
};

function generateRandomNumber(num) {
    const randomNumber = Math.floor(Math.random() * num) + 1;
    return randomNumber;
}

const pushQuestions = async (lastArray, eventId, pushFunction) => {
    for (let i = 0; i < lastArray.length; i++) {
        const docRef = doc(getDb(), "Events", eventId);
        const Ref = await addDoc(
            collection(docRef, lastArray[i].levelName),
            lastArray[i]
        );
    }
    console.log(lastArray);
    // pushFunction()
    return lastArray;
};
